import React, { useState } from 'react'
import GenericModal from '../../../components/GenericModal'
import CsvMappingUpload from '../../../components/CsvMappingUpload'
import Dropdown from '../../../components/Dropdown'
import CreateAndEditFacultyAndStaff from '../CreateAndEditFacultyAndStaff'
import { ButtonType } from '../../../components/GenericButton/styles'
import { notification } from '../../../components/Notifications'
import { getTerm } from '../../../store/slices/termsSlice/selectors'

const FacultyAndStaffTopbarActions: React.FC = () => {
  const [isUploadModal, setIsUploadModal] = useState<boolean>(false)
  const [isUploadRolesModal, setIsUploadRolesModal] = useState<boolean>(false)
  const [isCreateModal, setIsCreateModal] = useState<boolean>(false)

  const closeUploadModal = (): void => {
    setIsUploadModal(false)
    setIsUploadRolesModal(false)
  }

  const closeUploadRolesModal = (): void => {
    setIsUploadRolesModal(false)
  }

  const uploadApi = (): void => {
    setIsUploadModal(true)
  }

  const handleUploadRolesModal = (): void => {
    setIsUploadRolesModal(true)
  }

  const addManually = (): void => {
    setIsCreateModal(true)
  }

  const term = getTerm()

  const menuItems = [
    { text: 'Upload Faculty (.csv)', action: uploadApi },
    { text: 'Upload Faculty Roles (.csv)', action: handleUploadRolesModal },
    { text: 'Add Manually', action: addManually }
  ]

  return (
    <>
      <Dropdown menuItems={menuItems} label='Add Faculty' extraButtonProps={{ buttonType: ButtonType.Primary }} />
      <GenericModal
        isOpen={isCreateModal}
        title={'Add Faculty'}
        onClose={() => { setIsCreateModal(false) }}
        maxWidth='sm'
        action={false}
      >
        <CreateAndEditFacultyAndStaff handleCloseModal={() => { setIsCreateModal(false) }}/>
      </GenericModal>

      <CsvMappingUpload isOpen={isUploadModal} onClose={closeUploadModal} modalTitle="Faculty" csvHeaderEndpoint="/api/users/csv_headers" uploadCsvEndpoint="/api/users/?is_faculty=True" onSuccess={() => { notification('Operation Completed!', { variant: 'success' }) }}/>

      <CsvMappingUpload isOpen={isUploadRolesModal} onClose={closeUploadRolesModal} modalTitle="Roles" csvHeaderEndpoint="/api/users/roles/csv_headers" uploadCsvEndpoint={`/api/users/roles/?is_faculty=True&term_id=${term?.termId}`} onSuccess={() => { notification('Operation Completed!', { variant: 'success' }) }}
      />
    </>

  )
}

export default FacultyAndStaffTopbarActions
